// components/AuthProvider.jsx (DEMO)
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchAccess } from '../actions/access';

const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // just check if a demo user already exists
    dispatch(fetchAccess());
  }, [dispatch]);

  return children;
};

export default AuthProvider;